import React from "react";
import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { LegalEntityAuditType } from "../../../legalEntity/LegalEntity.types.ts";
import { legalEntityAuditTypeOptions } from "../../../legalEntity/legalEntityAuditOptions.ts";

export interface LegalEntityAuditTypeFieldProps {
    auditType?: LegalEntityAuditType;
    onChange: (auditType?: LegalEntityAuditType) => void;
    readOnly?: boolean;
    disabled: boolean;
    errorText?: string;
}

function LegalEntityAuditTypeField(props: LegalEntityAuditTypeFieldProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalSelect
            options={legalEntityAuditTypeOptions(translateString)}
            selectedItem={props.auditType ? props.auditType.toString() : null}
            onChange={props.readOnly ? () => {} : (auditType) => props.onChange(auditType ? (Number(auditType) as LegalEntityAuditType) : undefined)}
            placeholder={translateString("legalEntityAuditType")}
            label={translateString("legalEntityAuditType")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default LegalEntityAuditTypeField;
